import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ToastContainer } from 'react-toastify';
import UserProvider from './contexts/UserContext';
import { NavProvider } from './contexts/NavContext'; // ⬅️ Import NavProvider

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <UserProvider>
        <NavProvider> {/* ⬅️ Wrap App in NavProvider */}
          <App />
          <ToastContainer />
        </NavProvider>
      </UserProvider>
    </GoogleOAuthProvider>
  // </React.StrictMode>
);

reportWebVitals();
